export enum PageStatusCodes {
  success = 200,
  requestedTemporarilyMoved = 302,
  errorNotPermitted = 403,
  errorNotFound = 404,
  serverError = 500,
}
